import { render, staticRenderFns } from "./Offcanvas.vue?vue&type=template&id=671b8e73&scoped=true&"
import script from "./Offcanvas.vue?vue&type=script&lang=js&"
export * from "./Offcanvas.vue?vue&type=script&lang=js&"
import style0 from "./Offcanvas.vue?vue&type=style&index=0&id=671b8e73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b8e73",
  null
  
)

export default component.exports